import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, mergeProps as _mergeProps, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, vShow as _vShow, withDirectives as _withDirectives, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "w-full"
}
const _hoisted_2 = { class: "container w-full mx-auto" }
const _hoisted_3 = { class: "relative w-full shadow-lg rounded-lg bg-white px-4 py-3 pb-5" }
const _hoisted_4 = { class: "container mx-auto block w-full mt-4 space-y-4" }
const _hoisted_5 = { class: "flex flex-wrap -mx-2 space-y-4 md:space-y-0 mt-3" }
const _hoisted_6 = { class: "w-full px-2 md:w-1/1" }
const _hoisted_7 = { class: "flex flex-wrap -mx-2 space-y-4 md:space-y-0 mt-3" }
const _hoisted_8 = { class: "w-full px-2 md:w-1/1" }
const _hoisted_9 = { class: "flex flex-wrap -mx-2 space-y-4 md:space-y-0 mt-3" }
const _hoisted_10 = { class: "w-full px-2 md:w-1/1" }
const _hoisted_11 = { class: "flex flex-wrap -mx-2 space-y-4 md:space-y-0 mt-3" }
const _hoisted_12 = { class: "w-full px-2 md:w-1/1" }
const _hoisted_13 = { class: "flex flex-col md:flex-row my-2 gap-2 pt-3" }
const _hoisted_14 = ["disabled"]
const _hoisted_15 = ["disabled"]
const _hoisted_16 = { class: "container mx-auto block w-full space-y-2" }
const _hoisted_17 = { class: "w-full text-center" }
const _hoisted_18 = { class: "bg-red-100 text-sm border border-red-300 text-red-700 px-4 py-3 rounded relative" }
const _hoisted_19 = { class: "block sm:inline" }
const _hoisted_20 = { class: "flex flex-wrap -mx-2 space-y-4 md:space-y-0" }
const _hoisted_21 = { class: "w-full px-2 md:w-1/1" }
const _hoisted_22 = { class: "text-sm text-red-500 p-error" }
const _hoisted_23 = { class: "flex flex-wrap -mx-2 space-y-4 md:space-y-0" }
const _hoisted_24 = { class: "w-full px-2 md:w-1/1" }
const _hoisted_25 = { class: "text-sm text-red-500 p-error" }
const _hoisted_26 = { class: "flex flex-wrap -mx-2 space-y-4 md:space-y-0" }
const _hoisted_27 = { class: "w-full px-2 md:w-1/1" }
const _hoisted_28 = { class: "text-sm text-red-500 p-error" }
const _hoisted_29 = { class: "flex flex-col md:flex-row my-2 gap-2 pt-3" }
const _hoisted_30 = ["disabled"]
const _hoisted_31 = { class: "pi pi-spin pi-spinner mr-2" }
const _hoisted_32 = { class: "pi pi-check mr-2" }
const _hoisted_33 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_InputText = _resolveComponent("InputText")!
  const _component_Field = _resolveComponent("Field")!
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!
  const _component_CommonPrivateView = _resolveComponent("CommonPrivateView")!
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")!
  const _component_Form = _resolveComponent("Form")!
  const _component_Dialog = _resolveComponent("Dialog")!
  const _component_BlockUI = _resolveComponent("BlockUI")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_CommonPrivateView, null, {
      header: _withCtx(() => _cache[11] || (_cache[11] = [
        _createElementVNode("div", { class: "w-full flex flex-row py-6 text-white font-bold uppercase text-2xl [text-shadow:_2px_2px_0_rgb(155_155_155_/_60%)]" }, " PERFIL ", -1)
      ])),
      content: _withCtx(() => [
        (_ctx.usuarioEmpresa)
          ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
              _createElementVNode("div", _hoisted_2, [
                _createElementVNode("div", _hoisted_3, [
                  _cache[18] || (_cache[18] = _createElementVNode("div", { class: "flex items-center justify-between font-semibold text-lg" }, " MI PERFIL ", -1)),
                  _createElementVNode("div", _hoisted_4, [
                    _createElementVNode("div", _hoisted_5, [
                      _createElementVNode("div", _hoisted_6, [
                        _cache[12] || (_cache[12] = _createElementVNode("label", { class: "block mb-1" }, "Empresa (Razón social)", -1)),
                        _createVNode(_component_Field, {
                          name: "razonSocial",
                          modelValue: _ctx.usuarioEmpresa.empresa.razonSocial,
                          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.usuarioEmpresa.empresa.razonSocial) = $event))
                        }, {
                          default: _withCtx(({ field }) => [
                            _createVNode(_component_InputText, _mergeProps(field, {
                              type: "text",
                              class: "input-base !bg-gray-200",
                              readonly: ""
                            }), null, 16)
                          ]),
                          _: 1
                        }, 8, ["modelValue"])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_7, [
                      _createElementVNode("div", _hoisted_8, [
                        _cache[13] || (_cache[13] = _createElementVNode("label", { class: "block mb-1" }, "Nombre de fantasía", -1)),
                        _createVNode(_component_Field, {
                          name: "nombreFantasia",
                          modelValue: _ctx.usuarioEmpresa.empresa.nombreFantasia,
                          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.usuarioEmpresa.empresa.nombreFantasia) = $event))
                        }, {
                          default: _withCtx(({ field }) => [
                            _createVNode(_component_InputText, _mergeProps(field, {
                              type: "text",
                              class: "input-base !bg-gray-200",
                              readonly: ""
                            }), null, 16)
                          ]),
                          _: 1
                        }, 8, ["modelValue"])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_9, [
                      _createElementVNode("div", _hoisted_10, [
                        _cache[14] || (_cache[14] = _createElementVNode("label", { class: "block mb-1" }, "Mail", -1)),
                        _createVNode(_component_Field, {
                          name: "mailResponsable",
                          modelValue: _ctx.usuarioEmpresa.mailResponsable,
                          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.usuarioEmpresa.mailResponsable) = $event))
                        }, {
                          default: _withCtx(({ field }) => [
                            _createVNode(_component_InputText, _mergeProps(field, {
                              type: "text",
                              class: "input-base !bg-gray-200",
                              readonly: ""
                            }), null, 16)
                          ]),
                          _: 1
                        }, 8, ["modelValue"])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_11, [
                      _createElementVNode("div", _hoisted_12, [
                        _cache[15] || (_cache[15] = _createElementVNode("label", { class: "block mb-1" }, "Nombre completo", -1)),
                        _createVNode(_component_Field, {
                          name: "nombreCompleto",
                          modelValue: _ctx.usuarioEmpresa.nombreCompleto,
                          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.usuarioEmpresa.nombreCompleto) = $event))
                        }, {
                          default: _withCtx(({ field }) => [
                            _createVNode(_component_InputText, _mergeProps(field, {
                              type: "text",
                              class: "input-base !bg-gray-200",
                              readonly: ""
                            }), null, 16)
                          ]),
                          _: 1
                        }, 8, ["modelValue"])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_13, [
                      _createElementVNode("button", {
                        type: "button",
                        onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.showCambiarClave && _ctx.showCambiarClave(...args))),
                        class: "px-4 py-2 bg-transparent border-black hover:bg-black text-black font-semibold hover:text-white border rounded",
                        disabled: _ctx.isSubmitting
                      }, [
                        _createVNode(_component_font_awesome_icon, { icon: ['fas', 'lock'] }),
                        _cache[16] || (_cache[16] = _createTextVNode(" CAMBIAR CONTRASEÑA "))
                      ], 8, _hoisted_14),
                      _createElementVNode("button", {
                        type: "button",
                        onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.cancelarModificacion && _ctx.cancelarModificacion(...args))),
                        class: "px-4 py-2 bg-transparent border-red-700 hover:bg-red-700 text-red-700 font-semibold hover:text-white border rounded",
                        disabled: _ctx.isSubmitting
                      }, _cache[17] || (_cache[17] = [
                        _createElementVNode("i", { class: "pi pi-times mr-2" }, null, -1),
                        _createTextVNode("CANCELAR ")
                      ]), 8, _hoisted_15)
                    ])
                  ])
                ])
              ])
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }),
    _createVNode(_component_Dialog, {
      visible: _ctx.isCambiarClaveVisible,
      "onUpdate:visible": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.isCambiarClaveVisible) = $event)),
      modal: "",
      header: "Cambiar contraseña",
      style: { width: '40rem' }
    }, {
      default: _withCtx(() => [
        _createVNode(_component_Form, {
          onSubmit: _ctx.onSubmit,
          "validation-schema": _ctx.schema
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_16, [
              _withDirectives(_createElementVNode("div", _hoisted_17, [
                _createElementVNode("div", _hoisted_18, [
                  _createElementVNode("span", _hoisted_19, _toDisplayString(_ctx.errorCambioClave), 1)
                ])
              ], 512), [
                [_vShow, _ctx.errorCambioClave]
              ]),
              _createElementVNode("div", _hoisted_20, [
                _createElementVNode("div", _hoisted_21, [
                  _cache[19] || (_cache[19] = _createElementVNode("label", { class: "block mb-1" }, "Contraseña actual", -1)),
                  _createVNode(_component_Field, {
                    name: "claveActual",
                    modelValue: _ctx.claveActual,
                    "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.claveActual) = $event))
                  }, {
                    default: _withCtx(({ field, errors }) => [
                      _createVNode(_component_InputText, _mergeProps(field, {
                        type: "password",
                        class: ["input-base", { 'bg-gray-50': errors.length === 0, 'input-success': errors.length === 0 && field.value !== '', 'input-error': errors.length > 0}]
                      }), null, 16, ["class"]),
                      _createElementVNode("span", _hoisted_22, [
                        _createVNode(_component_ErrorMessage, { name: "claveActual" })
                      ])
                    ]),
                    _: 1
                  }, 8, ["modelValue"])
                ])
              ]),
              _createElementVNode("div", _hoisted_23, [
                _createElementVNode("div", _hoisted_24, [
                  _cache[20] || (_cache[20] = _createElementVNode("label", { class: "block mb-1" }, "Nueva contraseña", -1)),
                  _createVNode(_component_Field, {
                    name: "claveNueva",
                    modelValue: _ctx.claveNueva,
                    "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.claveNueva) = $event))
                  }, {
                    default: _withCtx(({ field, errors }) => [
                      _createVNode(_component_InputText, _mergeProps(field, {
                        type: "password",
                        class: ["input-base", { 'bg-gray-50': errors.length === 0, 'input-success': errors.length === 0 && field.value !== '', 'input-error': errors.length > 0}]
                      }), null, 16, ["class"]),
                      _createElementVNode("span", _hoisted_25, [
                        _createVNode(_component_ErrorMessage, { name: "claveNueva" })
                      ])
                    ]),
                    _: 1
                  }, 8, ["modelValue"])
                ])
              ]),
              _createElementVNode("div", _hoisted_26, [
                _createElementVNode("div", _hoisted_27, [
                  _cache[21] || (_cache[21] = _createElementVNode("label", { class: "block mb-1" }, "Repetir contraseña", -1)),
                  _createVNode(_component_Field, {
                    name: "claveRepetida",
                    modelValue: _ctx.claveRepetida,
                    "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.claveRepetida) = $event))
                  }, {
                    default: _withCtx(({ field, errors }) => [
                      _createVNode(_component_InputText, _mergeProps(field, {
                        type: "password",
                        class: ["input-base", { 'bg-gray-50': errors.length === 0, 'input-success': errors.length === 0 && field.value !== '', 'input-error': errors.length > 0}]
                      }), null, 16, ["class"]),
                      _createElementVNode("span", _hoisted_28, [
                        _createVNode(_component_ErrorMessage, { name: "claveRepetida" })
                      ])
                    ]),
                    _: 1
                  }, 8, ["modelValue"])
                ])
              ]),
              _createElementVNode("div", _hoisted_29, [
                _createElementVNode("button", {
                  type: "submit",
                  class: "flex-grow px-4 py-2 bg-transparent border-black hover:bg-black text-black font-semibold hover:text-white border rounded",
                  disabled: _ctx.isSubmitting
                }, [
                  _withDirectives(_createElementVNode("i", _hoisted_31, null, 512), [
                    [_vShow, _ctx.isSubmitting]
                  ]),
                  _withDirectives(_createElementVNode("i", _hoisted_32, null, 512), [
                    [_vShow, !_ctx.isSubmitting]
                  ]),
                  _cache[22] || (_cache[22] = _createTextVNode("ACEPTAR "))
                ], 8, _hoisted_30),
                _createElementVNode("button", {
                  type: "button",
                  onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.isCambiarClaveVisible = false)),
                  class: "flex-grow px-4 py-2 bg-transparent border-red-700 hover:bg-red-700 text-red-700 font-semibold hover:text-white border rounded",
                  disabled: _ctx.isSubmitting
                }, _cache[23] || (_cache[23] = [
                  _createElementVNode("i", { class: "pi pi-times mr-2" }, null, -1),
                  _createTextVNode("CANCELAR ")
                ]), 8, _hoisted_33)
              ])
            ])
          ]),
          _: 1
        }, 8, ["onSubmit", "validation-schema"])
      ]),
      _: 1
    }, 8, ["visible"]),
    _createVNode(_component_BlockUI, {
      blocked: _ctx.isSubmitting,
      fullScreen: ""
    }, null, 8, ["blocked"])
  ], 64))
}